module.exports = __webpack_public_path__ + "static/img/hot66.c553b30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingyun/hot66.jpg
// module id = hIFH
// module chunks = 1